import { Labels } from '../../shared-components/global/labels.js';

Labels.set('ui-upload', 'upload', 'Добавить');
Labels.set('ui-upload', 'uploadFiles', 'Загрузить файлы');
Labels.set('ui-upload', 'clear', 'Убрать файл');
